<div class="navbar">
    <div class="mobile-version__drawer-container">
        <button mat-button class="menu-button" (click)="sidenav.toggle()">
            <mat-icon>{{ isMenuOpen ? "menu_open" : "menu" }}</mat-icon>
        </button>
        <mat-sidenav-container class="sidenav-container">
            <mat-sidenav #sidenav autoFocus="false" mode="over" [(opened)]="isMenuOpen" class="sidenav"
                (click)="onSidenavClick()">
                <div class="drawer__buttons">
                    <mat-accordion>
                        <p class="menu-link" routerLink="/documente" [class.menu-active]="'/documente' === activeRoute"
                            (click)="setActiveRoute('/documente')">
                            <img src="assets/icons/companii.svg" alt="" />
                            <span>Documente</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('indoc-module.borderouri.list')" class="menu-link"
                            routerLink="/borderou" [class.menu-active]="'/borderou' === activeRoute"
                            (click)="setActiveRoute('/borderou')">
                            <img src="assets/icons/borderou.svg" alt="" />
                            <span>Borderou</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('indoc-module.rapoarte-activitati.list')"
                            class="menu-link" routerLink="/raport-activitate"
                            [class.menu-active]="'/raport-activitate' === activeRoute"
                            (click)="setActiveRoute('/raport-activitate')">
                            <img src="assets/icons/rapoarte-activitate.svg" alt="" />
                            <span>Rapoarte Activitate</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('indoc-module.rapoarte-activitati.matrix.list')"
                            class="menu-link" routerLink="/raport-activitate-detaliat"
                            [class.menu-active]="'/raport-activitate-detaliat' === activeRoute"
                            (click)="setActiveRoute('/raport-activitate-detaliat')">
                            <img src="assets/icons/rapoarte-activitate.svg" alt="" />
                            <span>Rapoarte Activitate (Detaliat)</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('indoc-module.rapoarte-amenzi.list')"
                            class="menu-link" routerLink="/raport" [class.menu-active]="'/raport' === activeRoute"
                            (click)="setActiveRoute('/raport')">
                            <img src="assets/icons/rapoarte-amenzi.svg" alt="" />
                            <span>Rapoarte (Amenzi)</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('indoc-module.inbox.list')" class="menu-link"
                            routerLink="/inbox" [class.menu-active]="'/inbox' === activeRoute"
                            (click)="setActiveRoute('/inbox')">
                            <img class="sidenav-request-btn" src="/assets/icons/cereri.svg" alt="" />
                            <span>Inbox</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('indoc-module.notificari-email.list')"
                            class="menu-link" routerLink="/notificari-email"
                            [class.menu-active]="'/notificari-email' === activeRoute"
                            (click)="setActiveRoute('/notificari-email')">
                            <img class="sidenav-request-btn" src="/assets/icons/notificari.svg" alt="" />
                            <span>Notificări Email</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('indoc-module.registre-documente.list')"
                            class="menu-link" routerLink="/registru" [class.menu-active]="'/registru' === activeRoute"
                            (click)="setActiveRoute('/registru')">
                            <img src="assets/icons/borderou.svg" alt="" />
                            <span>Registru</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('indoc-module.awbs.list')" class="menu-link"
                            routerLink="/awb" [class.menu-active]="'/awb' === activeRoute"
                            (click)="setActiveRoute('/awb')">
                            <img src="assets/icons/awb.svg" alt="" />
                            <span>AWB</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('indoc-module.sabloane-inbox-indoc.list')"
                            class="menu-link" routerLink="/sabloane" [class.menu-active]="'/sabloane' === activeRoute"
                            (click)="setActiveRoute('/sabloane')">
                            <img src="assets/icons/sabloane.svg" alt="" />
                            <span>Șabloane (Inbox)</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('indoc-module.beneficiari.list')" class="menu-link"
                            routerLink="/entitati" [class.menu-active]="'/entitati' === activeRoute"
                            (click)="setActiveRoute('/entitati')">
                            <img src="assets/icons/entitati.svg" alt="" />
                            <span>Beneficiari</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('indoc-module.evidenta-persoane.list')"
                            class="menu-link" routerLink="/verificare-evidenta"
                            [class.menu-active]="'/verificare-evidenta' === activeRoute"
                            (click)="setActiveRoute('/verificare-evidenta')">
                            <img src="assets/icons/verificare-evidenta.svg" alt="" />
                            <span>Verificare Evidență</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('indoc-module.persoane-decedate.list')"
                            class="menu-link" routerLink="/decedati" [class.menu-active]="'/decedati' === activeRoute"
                            (click)="setActiveRoute('/decedati')">
                            <img src="assets/icons/persoane-decedate.svg" alt="" />
                            <span>Persoane Decedate</span>
                        </p>
                        <p *ngIf="hasAnySettingsPermission()" class="menu-link" routerLink="/settings"
                            [class.menu-active]="'/settings' === activeRoute" (click)="setActiveRoute('/settings')">
                            <img src="/assets/icons/setari.svg" alt="" />
                            <span>Setări</span>
                        </p>

                        <mat-expansion-panel *ngIf="hasAnyAdministrativeSettingsPermission()" class="sidenav-accordion"
                            (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState">
                                <mat-panel-title class="sidenav-accordion">
                                    <div class="panel-title">
                                        <img src="/assets/icons/administrative.svg" alt="" />
                                        <span>Administrativ</span>
                                    </div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <p routerLink="/admin-settings" class="settings-option-menu"
                                [class.menu-active]="'/admin-settings' === activeRoute"
                                (click)="setActiveRoute('/admin-settings')">
                                <img src="/assets/icons/setari.svg" alt="" />
                                <span>Setari</span>
                            </p>
                        </mat-expansion-panel>
                    </mat-accordion>

                    <div class="footer">
                        <div class="logout-button" (click)="logout()">
                            <img src="assets/icons/logout.svg" alt="Deconectare" />
                            <div class="logout-button--text">Deconectare</div>
                        </div>
                    </div>
                </div>
            </mat-sidenav>
            <mat-sidenav-content>
                <main>
                    <!-- <router-outlet></router-outlet> -->
                </main>
            </mat-sidenav-content>
        </mat-sidenav-container>
    </div>



    <div class="hide-content">
        <!-- Directie Type Switcher Component -->
        <app-directie-type-switcher></app-directie-type-switcher>
    </div>

    <div class="d-flex flex-column">
        <div class="username clickable" (click)="navigateToProfile()" matTooltip="Vizualizare profil">{{ username }}
        </div>
        <!-- Job Type Switcher Component -->
        <app-job-type-switcher></app-job-type-switcher>
    </div>
    <div class="username__icon">
        <div class="username__icon clickable" (click)="navigateToProfile()" matTooltip="Vizualizare profil">
            <div class="username__icon--letters">{{ usernameLetters }}</div>
        </div>
    </div>

    <div class="notification" [popover]="popTemplateNotifications" [adaptivePosition]="true"
        #notificationsPopover="bs-popover" placement="bottom" container="body" boundariesElement="scrollParent">
        <div class="notifications" [ngClass]="{ 'move-up': !userNotifications && !isLoading }">
            <mat-spinner color="primary" diameter="40" *ngIf="isLoading"></mat-spinner>
            <img src="assets/icons/icon-bell.svg" alt="Notificari" />
            <div class="notifications--chip" [ngClass]="{ 'hide-chip': isLoading }">
                <span *ngIf="!isLoading && userNotifications">{{ userNotifications }}</span>
            </div>
        </div>
    </div>

    <ng-template #popTemplateNotifications>
        <p class="title">Aveți {{ userNotifications }} notificări</p>
        <div class="notification-popup d-flex flex-column">
            <div class="notification-message-container">
                <button type="button"
                    class=" btn btn-light subtitle d-flex justify-content-start align-items-center gap-2"
                    (click)="onButtonClick({id: '1', name: 'Documente'})">
                    <i class="fa-solid fa-envelope info"></i> {{notification['modified']}} Solicitări necesită
                    atenția dvs.
                </button>

                <button type="button"
                    class="btn btn-light subtitle d-flex justify-content-start align-items-center gap-2"
                    (click)="onButtonClick({id: '2', name: 'Mesaje interne'})">
                    <i class="fa-solid fa-triangle-exclamation warning"></i> {{notification['messages']}}
                    Mesaje interne pentru dvs.
                </button>
            </div>
        </div>
    </ng-template>
</div>